import React from 'react';
import { MuiModal } from 'ui/MuiModal';
import { ILocationConfig } from '../models/LocationModel';
import { CreateLocationStepper } from './CreateLocationStepper';

interface CreateLocationModalProps {
    onClose?: () => void;
    onError: (message: string) => void;
    onSuccess: (locationTitle: string) => void;
    open: boolean;
    locationConfig: ILocationConfig;
}

export const CreateLocationModal: React.FC<CreateLocationModalProps> = ({
    open,
    onClose,
    onError,
    onSuccess,
    locationConfig
}) => (
    <MuiModal paperMaxWidth={640} open={open} onClose={onClose} disableBackdropClick padding={false}>
        <CreateLocationStepper
            onClose={onClose}
            onSuccess={onSuccess}
            onError={onError}
            locationConfig={locationConfig}
        />
    </MuiModal>
);
